import { scroller } from 'react-scroll';


export const objectHasAnyKeys = (keys, object) => {
  for (let key of keys) {
    if (object[key]) return true
  }
  return false
}

export const objectHasAllKeys = (keys, object) => {
  for (let key of keys) {
    if (!object[key]) return false
  }
  return true
}

export const scrollTo = (location) => (
  scroller.scrollTo(location, {
    duration: 800,
    delay: 0,
    smooth: true
  })
)
